import React, { useState } from 'react'
import NavigationButtons from '../../../components/NavigationButtons';
import { BsEye } from 'react-icons/bs';

const ScheduleActivities = () => {
    const tableData = [
        { region: "Sindh", city: "Karachi", school: "DHA", startDate: "18-January" },
        { region: "Sindh", city: "Karachi", school: "DHA", startDate: "16-February" },
        { region: "Punjab", city: "Lahore", school: "Gulberg", startDate: "5-March" },
        { region: "Punjab", city: "Lahore", school: "Gulberg", startDate: "10-April" },
        { region: "Sindh", city: "Karachi", school: "DHA", startDate: "22-May" },
        { region: "Sindh", city: "Karachi", school: "DHA", startDate: "30-June" },
        { region: "Punjab", city: "Lahore", school: "Gulberg", startDate: "12-July" },
        { region: "Sindh", city: "Karachi", school: "DHA", startDate: "8-August" }
    ];
    const [buttonType, setButtonType] = useState("class8")
    return (
        <div className='p-8 mt-8 space-y-4'>
            <div className="flex items-center gap-8 mt-[-50px] mb-4">
                <button onClick={() => setButtonType("class8")} className={`  h-[40px] w-[130px] font-medium  border  border-[#FF9348] rounded-lg ${buttonType === "class8" ? "border  bg-[#FF9348] text-white" : "bg-white text-[#FF9348]"} `}>
                    Class 8
                </button>
                <button onClick={() => setButtonType("A'Level")} className={`  h-[40px] w-[130px] border  border-[#FF9348] font-medium rounded-lg ${buttonType === "A'Level" ? "border  bg-[#FF9348] text-white" : "bg-white text-[#FF9348]"} `}>
                    A Level
                </button>
                <button onClick={() => setButtonType("O'Level")} className={`  h-[40px] w-[130px] border  border-[#FF9348] font-medium rounded-lg ${buttonType === "O'Level" ? "border  bg-[#FF9348] text-white" : "bg-white text-[#FF9348] "} `}>
                    O Level
                </button>

            </div>
            <div className="bg-white border-gray-400 rounded-lg border w-full relative p-4">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="text-[16px] font-medium">
                            <tr>
                                <th className="px-24 py-3 text-left text-gray-700 font-semibold">Region</th>
                                <th className="px-24 py-3 text-left text-gray-700 font-semibold">City</th>
                                <th className="px-24 py-3 text-left text-gray-700 font-semibold">School</th>
                                <th className="px-24 py-3 text-left text-gray-700 font-semibold">Start Date</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-400">
                            {tableData.map((row, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    <td className="px-24 py-3 whitespace-nowrap">{row.region}</td>
                                    <td className="px-24 py-3 whitespace-nowrap">{row.city}</td>
                                    <td className="px-24 py-3 whitespace-nowrap">{row.school}</td>
                                    <td className="px-24 py-3 whitespace-nowrap flex items-center gap-2">
                                        {/* Date Selector (1 to 31) */}
                                        <select className="w-[80px] border rounded-md p-1">
                                            <option value="">Date</option>
                                            {Array.from({ length: 31 }, (_, i) => (
                                                <option key={i + 1} value={i + 1}>
                                                    {i + 1}
                                                </option>
                                            ))}
                                        </select>

                                        {/* Month Selector (January to December) */}
                                        <select className="w-[100px] border rounded-md p-1">
                                            <option value="">Month</option>
                                            {[
                                                "January", "February", "March", "April", "May", "June",
                                                "July", "August", "September", "October", "November", "December"
                                            ].map((month, index) => (
                                                <option key={index} value={month}>
                                                    {month}
                                                </option>
                                            ))}
                                        </select>
                                    </td>


                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="flex justify-between w-full gap-4">
                <div className="mt-2">
                    <NavigationButtons />
                   
                </div>
                <button className="flex items-center justify-center gap-1 bg-blue-600 text-white px-16 py-1 font-medium text-[18px] rounded-lg text-sm">
                        Save

                    </button>
            </div>
        </div>
    )
}

export default ScheduleActivities